import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	OnInit,
	Output,
} from '@angular/core';
import { AdjacentParcel, SavedPin } from '@models/teranet';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { SalePinState } from '@state/sale_pins';
import { Observable } from 'rxjs';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ICON } from '@core/util/icon';

@UntilDestroy()
@Component({
	selector: 'app-compare-names',
	templateUrl: './compare-names.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TeranetCompareNamesComponent implements OnInit {
	public _selectedPin: SavedPin;
	public showOnlySimilar = true;
	public ICON = ICON;
	public parcels: AdjacentParcel[] = [];
	public filteredParcels: AdjacentParcel[] = [];

	@SelectSnapshot(SelectedMatter.id) matterId;
	@Select(SalePinState.getSelected) selectedPin$: Observable<SavedPin>;

	@Output() onClose: EventEmitter<void> = new EventEmitter();

	constructor(private routeService: NavigationService) {}

	ngOnInit(): void {
		this.selectedPin$.pipe(untilDestroyed(this)).subscribe((pin) => {
			if (!pin) {
				this.routeService.goToMatter_TitleSearch(this.matterId);
			}

			this._selectedPin = pin;
			this.parcels = pin?.map?.adjacent_parcels;
		});
	}

	getSurname(owner: string): string {
		const splits = owner.split(',');

		if (splits?.length > 0) {
			return splits[0].toLowerCase();
		}

		return owner.toLowerCase();
	}

	toggleSimilar(): void {
		this.showOnlySimilar = !this.showOnlySimilar;
	}

	close() {
		this.onClose.emit();
	}
}
